/* Judge.me, read live (PORT-NOTES 28, 34, 47 and 53): the owners a shop page quotes, chosen by their Judge.me review ids, the
   reel of the range's other owners, a product's review grid, and the owners' stack with the pile of their photographs, from
   Judge.me's public widget feed, drawn in the review files' markup. Nothing from the feed is typed into the theme. The port's
   own script, copied into assets by tools/build-assets.mjs. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var STAR = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 1.6l2.5 5.2 5.7.8-4.1 4 1 5.7-5.1-2.7-5.1 2.7 1-5.7-4.1-4 5.7-.8z"/></svg>';
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function stars(n) { var s = ''; for (var i = 0; i < n; i++) s += STAR; return '<span class="ti-stars" role="img" aria-label="Rated ' + n + ' out of 5">' + s + '</span>'; }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; }
  function when(s) {
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s || '');
    return m ? (+m[3]) + ' ' + MONTHS[+m[2] - 1] + ' ' + m[1] : '';
  }
  /* one review from the feed's markup: its id, score, author, title, words (paragraphs kept), date, photograph */
  function read(r) {
    var q = function (sel) { return r.querySelector(sel); };
    var body = q('.jdgm-rev__body');
    var paras = body ? [].slice.call(body.querySelectorAll('p')).map(function (p) { return p.textContent.trim(); }).filter(Boolean) : [];
    if (!paras.length && body) paras = [body.textContent.trim()];
    var pics = [].slice.call(r.querySelectorAll('.jdgm-rev__pic-link:not(.jdgm-rev__product-picture)')).map(function (p) { return p.getAttribute('data-mfp-src') || p.getAttribute('href') || ''; }).filter(function (u) { return u.indexOf('https://') === 0; });
    var src = pics[0] || '';
    var stamp = q('.jdgm-rev__timestamp');
    return {
      id: r.getAttribute('data-review-id'),
      score: +((q('.jdgm-rev__rating') || { getAttribute: function () { return '5'; } }).getAttribute('data-score')) || 5,
      verified: r.getAttribute('data-verified-buyer') === 'true',
      author: ((q('.jdgm-rev__author') || {}).textContent || '').trim(),
      title: ((q('.jdgm-rev__title') || {}).textContent || '').trim(),
      words: paras,
      date: stamp ? stamp.getAttribute('data-content') || '' : '',
      photo: src,
      photos: pics
    };
  }
  function feed(shop, id) {
    return fetch('https://api.judge.me/reviews/reviews_for_widget?url=' + shop + '&shop_domain=' + shop + '&platform=shopify&page=1&per_page=50&product_id=' + encodeURIComponent(id))
      .then(function (r) { return r.ok ? r.json() : { html: '' }; })
      .then(function (j) { return [].slice.call(new DOMParser().parseFromString(j.html || '', 'text/html').querySelectorAll('.jdgm-rev[data-review-id]')).map(read); })
      .catch(function () { return []; });
  }
  function who(r, el) { return '<b>' + esc(r.author) + '</b>' + (r.verified ? esc(el.getAttribute('data-verified')) + ' · ' : '') + when(r.date); }
  function lead(r, el) {
    return '<figure class="ti-own__lead is-in" data-rise style="--d:0ms;--focal: 50% 50%">' +
      (r.photo ? '<span class="ti-own__m" aria-hidden="true"><img src="' + esc(r.photo) + '" alt="" loading="lazy" decoding="async"></span>' : '') +
      stars(r.score) + '<blockquote class="ti-own__q">' + esc(r.words.join(' ')) + '</blockquote><figcaption class="ti-own__who">' + who(r, el) +
      (el.getAttribute('data-source') ? ' · ' + esc(el.getAttribute('data-source')) : '') + '</figcaption></figure>';
  }
  function card(r, el, d) {
    return '<article class="ti-rev__c is-in" data-jdgm="review" data-review-id="' + esc(r.id) + '" data-rise style="--d:' + d + 'ms">' + stars(r.score) + '<blockquote>' + (r.title ? '<p class="ti-rev__t">' + esc(r.title) + '</p>' : '') +
      r.words.map(esc).join('<br>') + '</blockquote><div class="ti-rev__w"><span>' + who(r, el) + '</span></div></article>';
  }
  function reelCard(r, el) {
    return '<article class="ti-reel__c">' + stars(r.score) + '<blockquote>' + (r.title ? '<p class="ti-rev__t">' + esc(r.title) + '</p>' : '') +
      r.words.map(esc).join('<br>') + '</blockquote><p class="ti-reel__w">' + who(r, el) + '</p></article>';
  }
  /* the reel rolls as ti-base.js rolls the Google one: a hidden copy follows the cards so the loop shows no seam */
  function roll(reel, track) {
    if (reduce || track.children.length < 3) return;
    [].slice.call(track.children).forEach(function (c) {
      var k = c.cloneNode(true);
      k.setAttribute('aria-hidden', 'true');
      track.appendChild(k);
    });
    function pace() { reel.style.setProperty('--reel-dur', Math.max(40, Math.round(track.scrollWidth / 2 / 36)) + 's'); }
    pace();
    reel.classList.add('is-rolling');
    window.addEventListener('resize', pace);
  }
  function fill(el) {
    var shop = el.getAttribute('data-shop-domain');
    var ids = (el.getAttribute('data-products') || '').split(',').filter(Boolean);
    if (!shop || !ids.length) return;
    Promise.all(ids.map(function (id) { return feed(shop, id); })).then(function (lists) {
      var all = [].concat.apply([], lists).sort(function (a, b) { return a.date < b.date ? 1 : a.date > b.date ? -1 : 0; });
      var byId = {}; all.forEach(function (r) { byId[r.id] = r; });
      var quoted = [];
      var own = el.querySelector('[data-jdgm-own]');
      if (own) {
        var html = '';
        var l = byId[own.getAttribute('data-lead')];
        if (l) { quoted.push(l.id); own.insertAdjacentHTML('afterbegin', lead(l, el)); }
        var side = own.querySelector('.ti-own__side');
        (own.getAttribute('data-side') || '').split(',').filter(Boolean).forEach(function (id, i) {
          var r = byId[id.trim()];
          if (r) { quoted.push(r.id); html += card(r, el, i ? 140 : 80); }
        });
        if (side && html) side.insertAdjacentHTML('afterbegin', html);
      }
      if (el.hasAttribute('data-jdgm-grid')) {
        var want = +el.getAttribute('data-jdgm-grid') || 4;
        var grid = (el.getAttribute('data-picks') || '').split(',').map(function (x) { return byId[x.trim()]; }).filter(Boolean);
        all.forEach(function (r) { if (grid.length < want && grid.indexOf(r) < 0 && r.score >= 4 && r.words.join('').length > 0) grid.push(r); });
        el.innerHTML = grid.slice(0, want).map(function (r, i) { return card(r, el, i * 60); }).join('');
      }
      var reel = el.querySelector('[data-jdgm-reel]');
      if (reel) {
        var track = reel.querySelector('[data-reel-track]');
        var n = +reel.getAttribute('data-jdgm-reel') || 14;
        var picks = all.filter(function (r) { return r.score >= 4 && r.words.join('').length > 0 && quoted.indexOf(r.id) < 0 && skip().indexOf(r.id) < 0; }).slice(0, n);
        if (!picks.length) { reel.hidden = true; return; }
        track.innerHTML = picks.map(function (r) { return reelCard(r, el); }).join('');
        reel.classList.add('is-in');
        roll(reel, track);
      }
    });
  }
  /* every review id the page's sections pick: the grid's (id,id) and the stack's (product:id:focal:light|...) */
  function skip() {
    var out = [];
    [].forEach.call(document.querySelectorAll('[data-picks]'), function (e) {
      var v = e.getAttribute('data-picks') || '';
      (v.indexOf(':') >= 0 ? v.split('|').map(function (p) { return p.split(':')[1]; }) : v.split(',')).forEach(function (id) { if (id && id.trim()) out.push(id.trim()); });
    });
    return out;
  }
  /* the owners' stack: a print and its words a pick, the pile dealt from the picks' photographs; then the shop script turns it */
  var ROT = [-2, 4, -7, 8, -11];
  function nw(t) { return esc(t).replace(/X-Strip/g, '<span class="ti-nw">X-Strip</span>'); }
  function fillStack(el) {
    var shop = el.getAttribute('data-shop-domain');
    var picks = (el.getAttribute('data-picks') || '').split('|').map(function (p) { var b = p.split(':'); return { product: b[0], id: (b[1] || '').trim(), focal: b[2] || '', light: b.slice(3).join(':') }; }).filter(function (p) { return p.product && p.id; });
    var ids = picks.map(function (p) { return p.product; }).filter(function (x, i, a) { return a.indexOf(x) === i; });
    if (!shop || !ids.length) return;
    Promise.all(ids.map(function (id) { return feed(shop, id); })).then(function (lists) {
      var byId = {}; [].concat.apply([], lists).forEach(function (r) { byId[r.id] = r; });
      var found = picks.map(function (p) { var r = byId[p.id]; return r && r.photo ? { r: r, p: p } : null; }).filter(Boolean).slice(0, 5);
      if (!found.length) { el.closest('section').hidden = true; return; }
      var prints = el.querySelector('.ti-stack__prints'), words = el.querySelector('.ti-stack__words'), nav = el.querySelector('.ti-stack__nav');
      var vf = el.getAttribute('data-verified') || '', src = el.getAttribute('data-source') || '', alt = el.getAttribute('data-alt') || '';
      prints.innerHTML = found.map(function (x, i) {
        var r = x.r, focal = x.p.focal && x.p.focal !== '50% 50%' ? ' style="object-position:' + esc(x.p.focal) + '"' : '';
        return '<figure class="ti-pin__print ti-stack__p" data-i="' + i + '" data-pos="' + i + '" style="--rot:' + ROT[i] + 'deg"><div class="ti-pin__well"><img src="' + esc(r.photo) + '"' + focal + ' alt="' + esc(alt) + '" loading="lazy" decoding="async"></div>' +
          '<figcaption><span class="ti-pin__rating">' + stars(r.score) + '<span class="ti-pin__source">' + esc(src) + '</span></span><span class="ti-pin__title">' + esc(r.author.split(' ')[0].replace(/\.$/, '')) + '</span><span class="ti-pin__spec">' + nw(x.p.light) + '</span></figcaption></figure>';
      }).join('');
      words.innerHTML = found.map(function (x, i) {
        var r = x.r, n = r.words.join(' ').split(/\s+/).length;
        return '<article class="ti-rev__c ti-stack__w' + (i ? '' : ' is-on') + (n > 90 ? ' is-long' : '') + '" data-i="' + i + '" data-jdgm="review" data-review-id="' + esc(r.id) + '"' + (i ? ' aria-hidden="true"' : '') + '>' + stars(r.score) +
          '<blockquote>' + (r.title ? '<p class="ti-rev__t">' + esc(r.title) + '</p>' : '') + r.words.map(esc).join('<br>') + '</blockquote><div class="ti-rev__w"><span><b>' + esc(r.author) + '</b>' +
          (r.verified ? esc(vf) : esc(src)) + (when(r.date) ? ' · ' + when(r.date) : '') + (x.p.light ? ' · ' + nw(x.p.light) : '') + '</span></div></article>';
      }).join('');
      nav.innerHTML = found.map(function (x, i) { return '<button type="button" class="ti-stack__dot' + (i ? '' : ' is-on') + '" data-stack-to="' + i + '" aria-label="' + esc(x.r.author) + '’s review"' + (i ? '' : ' aria-current="true"') + '></button>'; }).join('');
      /* the pile: the picks' photographs, every one, dealt to the places that name them (a place names one by its number) */
      var pics = []; found.forEach(function (x) { x.r.photos.forEach(function (u) { if (pics.indexOf(u) < 0) pics.push(u); }); });
      [].forEach.call(el.closest('section').querySelectorAll('[data-pile]'), function (slot) {
        var u = pics[((+slot.getAttribute('data-pile') || 1) - 1) % pics.length];
        var well = slot.querySelector('.ti-pin__well');
        if (u && well && !well.firstChild) well.innerHTML = '<img src="' + esc(u) + '" alt="" loading="lazy" decoding="async">';
      });
      el.setAttribute('data-filled', '1');
      if (window.tiStack) window.tiStack(el);
    });
  }
  var stacks = [].slice.call(document.querySelectorAll('[data-jdgm-stack]'));
  stacks.forEach(function (el) {
    if ('IntersectionObserver' in window) {
      var so = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { so.unobserve(e.target); fillStack(e.target); } }); }, { rootMargin: '800px 0px' });
      so.observe(el);
    } else fillStack(el);
  });
  var els = [].slice.call(document.querySelectorAll('[data-jdgm-feed]'));
  if (!els.length) return;
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); fill(e.target); } }); }, { rootMargin: '600px 0px' });
    els.forEach(function (el) { io.observe(el); });
  } else els.forEach(fill);
})();
